<template>
  <el-row>
    <table-template :queryParams="queryParams" actionUrl="/secondHandCarMarket/findIntranetActionRecord.action"
                    ref="seriesContentTable">
      <template slot="search">
        <el-row>
          <el-form :inline="true" class="demo-form-inline">

            <el-form-item>
              <el-date-picker
                  @change="onDateTimeChange"
                  end-placeholder="结束日期"
                  range-separator="至"
                  start-placeholder="开始日期"
                  type="datetimerange"
                  v-model="queryParams.startEndTime">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="搜索用户手机号" v-model="queryParams.keyword"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="$refs.seriesContentTable.search()" type="primary">搜索</el-button>
            </el-form-item>
          </el-form>
        </el-row>

      </template>
      <template slot="item">
        <el-table-column
            label="用户名称"
            prop="contacts">
          <template scope="scope">
            {{scope.row.contacts}}
          </template>
        </el-table-column>
        <el-table-column
            label="用户手机号"
            prop="phone">
        </el-table-column>
        <el-table-column
            label="查价车型"
            prop="seriesName">
        </el-table-column>
        <el-table-column
            label="创建时间"
        >
          <template scope="scope">
            <p>{{scope.row.createTime | dateTimeFormat}}</p>
          </template>
        </el-table-column>

        <el-table-column
                label="操作">
          <template scope="scope">
          </template>
        </el-table-column>

      </template>
    </table-template>
  </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import BasicModel from '@/framework/basic/BasicModel'
export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'intractionActionSeriesContent',
  data: function () {
    return {
      queryParams: { status: 1 }
    }
  },
  watch: {
    'queryParams.status': function () {
      this.$refs.seriesContentTable.search()
    }
  },
  methods: {

    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.$refs.seriesContentTable.search()
    }

  }
}
</script>

<style scoped>
</style>
